import React from "react";

// Components
import { Switch as SwitchBase } from "antd";
import { Label, Text } from "../Input/Input.styles";
import { SwitchWrapper } from "./Switch.styles";

interface Props {
  checked: boolean;
  defaultChecked?: boolean;
  checkedChildren?: string;
  unCheckedChildren?: string;
  label?: string;
  disabled?: boolean;
  handleChange: (checked: boolean) => void;
  displayOnly?: boolean;
  displayOnlyLabels?: string[];
}

const Switch: React.FC<Props> = ({
  checked,
  defaultChecked,
  checkedChildren,
  unCheckedChildren,
  label,
  disabled,
  handleChange,
  displayOnly,
  displayOnlyLabels,
}) => {
  const renderDisplay = () => {
    if (displayOnlyLabels) {
      return <Text>{checked ? displayOnlyLabels[0] : displayOnlyLabels[1]}</Text>;
    }
    return <Text>{checked ? "Active" : "Archived"}</Text>;
  };

  return (
    <SwitchWrapper>
      {label ? <Label>{label}</Label> : null}
      {displayOnly ? (
        renderDisplay()
      ) : (
        <SwitchBase
          checked={checked}
          disabled={disabled}
          defaultChecked={defaultChecked}
          checkedChildren={checkedChildren}
          unCheckedChildren={unCheckedChildren}
          onChange={handleChange}
        />
      )}
    </SwitchWrapper>
  );
};
export default Switch;
